module.exports = __webpack_public_path__ + "img/寻缘树.800ee1b1.png";